import React from 'react';

import LightboxImage from './LightboxImage';
import { withLinks, withParagraphs } from './utils';

const Timeline = ({ events }) => (
  <div className="pt4 pt0-l">
    <h3 className="mt0 f3 f2-ns ttu tc tl-ns">Fotolauget si tidslinje</h3>
    <ul className="b-timeline">
      {events.map(event => (
        <li className="m-event" key={event.id}>
          <time className="m-event-date">
            <span className="a-event-date-month">{event.title}</span>
            <span className="a-event-date-year">{event.year}</span>
          </time>
          <div className="a-event-icon" />
          <div className="m-event-block">
            {event.thumbnail && (
              <div key={event.id} className="a-image-wrapper">
                <LightboxImage
                  thumbnail={event.thumbnail}
                  images={event.images}
                />
              </div>
            )}
            <h2 className="a-event-title">{event.title}</h2>
            {withLinks(withParagraphs(event.description, 'a-event-text'))}
          </div>
        </li>
      ))}
    </ul>
  </div>
);

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/TimelineComponent.js